import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "prate__head" }
const _hoisted_2 = { class: "prate__meta" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "prate__score" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "prate__bars"
}
const _hoisted_7 = {
  key: 1,
  class: "prate__note"
}
const _hoisted_8 = {
  key: 2,
  class: "prate__note"
}
const _hoisted_9 = {
  key: 3,
  class: "prate__note"
}
const _hoisted_10 = {
  key: 4,
  class: "prate__wait"
}
const _hoisted_11 = { class: "prate__actions" }

import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import { fetchSellerReviews, type SellerMallReview } from '@/api/mallReview'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductRatingModal',
  props: {
    productCode: {},
    productName: {},
    rating: {},
    reviewCount: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const router = useRouter()
const titleId = `prate-${Math.random().toString(36).slice(2, 7)}`
const panelEl = ref<HTMLElement | null>(null)
const reviews = ref<SellerMallReview[]>([])
const loaded = ref(false)
const failed = ref(false)

const shownRating = computed(() => {
  if (loaded.value && reviews.value.length) {
    const sum = reviews.value.reduce((acc, review) => acc + Number(review.rating || 0), 0)
    return (sum / reviews.value.length).toFixed(1)
  }
  return Number(props.rating || 0).toFixed(1)
})

const shownCount = computed(() => (loaded.value ? reviews.value.length : Number(props.reviewCount || 0)))

const roundedStars = computed(() => Math.max(0, Math.min(5, Math.round(Number(shownRating.value) || 0))))

const buckets = computed(() => {
  const counts = [0, 0, 0, 0, 0]
  reviews.value.forEach((review) => {
    const star = Math.min(5, Math.max(1, Math.round(Number(review.rating) || 0)))
    counts[star - 1] += 1
  })
  const total = reviews.value.length || 1
  return [5, 4, 3, 2, 1].map((star) => ({
    star,
    count: counts[star - 1],
    share: Math.round((counts[star - 1] / total) * 100),
  }))
})

const waiting = computed(() => reviews.value.filter((review) => !String(review.reply || '').trim()).length)

function openDetail() {
  router.push({
    path: '/seller/reviews',
    query: { tab: 'review', productCode: props.productCode },
  })
}

function onKey(event: KeyboardEvent) {
  if (event.key === 'Escape') emit('close')
}

onMounted(async () => {
  document.addEventListener('keydown', onKey)
  await nextTick()
  panelEl.value?.focus()
  try {
    const all = await fetchSellerReviews()
    reviews.value = all.filter((review) => review.productCode === props.productCode)
  } catch {
    failed.value = true
  } finally {
    loaded.value = true
  }
})

onUnmounted(() => {
  document.removeEventListener('keydown', onKey)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "prate",
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": titleId,
    onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (emit('close')), ["prevent"]), ["esc"]))
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "prate__catch",
      "aria-label": "닫기",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }),
    _createElementVNode("div", {
      class: "prate__panel",
      tabindex: "-1",
      ref_key: "panelEl",
      ref: panelEl
    }, [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", { id: titleId }, "평점"),
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("strong", null, _toDisplayString(__props.productName), 1),
            (__props.productCode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.productCode), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "prate__close",
          "aria-label": "평점 닫기",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-close",
            size: 20
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("strong", null, _toDisplayString(shownRating.value), 1),
        _createElementVNode("div", null, [
          _createElementVNode("span", {
            class: "prate__stars",
            "aria-label": `5점 만점에 ${shownRating.value}점`
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
              return _createVNode(AppIcon, {
                key: star,
                icon: star <= roundedStars.value ? 'mdi-star' : 'mdi-star-outline',
                size: 18
              }, null, 8, ["icon"])
            }), 64))
          ], 8, _hoisted_5),
          _createElementVNode("p", null, "후기 " + _toDisplayString(shownCount.value) + "건", 1)
        ])
      ]),
      (loaded.value && reviews.value.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buckets.value, (row) => {
              return (_openBlock(), _createElementBlock("li", {
                key: row.star
              }, [
                _createElementVNode("span", null, _toDisplayString(row.star) + "점", 1),
                _createElementVNode("i", null, [
                  _createElementVNode("b", {
                    style: _normalizeStyle({ width: `${row.share}%` })
                  }, null, 4)
                ]),
                _createElementVNode("em", null, _toDisplayString(row.count), 1)
              ]))
            }), 128))
          ]))
        : (!loaded.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, "후기를 집계하는 중입니다."))
          : (failed.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "별점 분포는 지금 불러오지 못했습니다. 자세히 보기에서 후기를 확인할 수 있습니다."))
            : (_openBlock(), _createElementBlock("p", _hoisted_9, "아직 등록된 후기가 없습니다.")),
      (waiting.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, "답글 없는 후기 " + _toDisplayString(waiting.value) + "건", 1))
        : _createCommentVNode("", true),
      _createElementVNode("footer", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn sui-btn--ghost",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
        }, "닫기"),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn sui-btn--primary",
          onClick: openDetail
        }, "자세히 보기")
      ])
    ], 512)
  ], 32))
}
}

})